import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { activateAccount } from '../services/authService';

const ActivatePage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await activateAccount(email);
      setSent(true);
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  // ─── Mail gönderildi ekranı ───────────────────────────────────────────────
  if (sent) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.iconWrapper}>✉️</div>
          <h2 style={styles.title}>Linki Gönderdik</h2>
          <p style={styles.description}>
            <strong>{email}</strong> adresine şifre belirleme linki gönderildi.
            Lütfen gelen kutunuzu (ve spam klasörünüzü) kontrol edin.
          </p>
          <p style={styles.hint}>
            Link 72 saat geçerlidir. Süresi dolduysa bu sayfadan tekrar talep edebilirsiniz.
          </p>
          <button style={styles.secondaryButton} onClick={() => setSent(false)}>
            Tekrar Gönder
          </button>
          <p style={styles.backLink}>
            <span style={styles.link} onClick={() => navigate('/login')}>
              ← Giriş sayfasına dön
            </span>
          </p>
        </div>
      </div>
    );
  }

  // ─── Email giriş formu ────────────────────────────────────────────────────
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>İlk Kez Giriş</h2>
        <p style={styles.description}>
          Sisteme ilk kez giriş yapıyorsanız email adresinizi girin.
          Size şifre belirleme linki gönderilecektir.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email Adresi</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="ornek@sirket.com"
              required
              autoFocus
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Link Gönder'}
          </button>
        </form>
        <p style={styles.backLink}>
          <span style={styles.link} onClick={() => navigate('/login')}>
            ← Giriş sayfasına dön
          </span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f0f2f5',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    width: '360px',
  },
  iconWrapper: {
    textAlign: 'center',
    fontSize: '40px',
    marginBottom: '16px',
  },
  title: {
    textAlign: 'center',
    marginBottom: '8px',
    color: '#1a1a2e',
    fontSize: '20px',
  },
  description: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#555',
    marginBottom: '24px',
    lineHeight: '1.6',
  },
  hint: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#888',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  field: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '13px',
    color: '#333',
    fontWeight: '500',
  },
  input: {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    fontSize: '14px',
    outline: 'none',
  },
  error: {
    color: '#e53e3e',
    fontSize: '13px',
    marginBottom: '8px',
  },
  button: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#1a1a2e',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '15px',
    cursor: 'pointer',
    marginTop: '4px',
  },
  secondaryButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: 'transparent',
    color: '#1a1a2e',
    border: '1px solid #1a1a2e',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    marginBottom: '12px',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '16px',
    fontSize: '13px',
  },
  link: {
    color: '#1a1a2e',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

export default ActivatePage;